export const css = {
	root: 'TuNBX_NT',
	copyright: 'XfyZS2YT',
	selector: '_3L2kiWW-',
	privacypolicy: '_3st7JvVJ',
	disclaimer: 'yDMl4ONn',
	' _key': 'certwise-theme/certwise/lcc-app/footer'
};

export default css;
